import { useAppRouter } from '@/common/route/useAppRouter';
import { useCrudActions } from '@/common/view/useCrudActions';
import { ROUTE_NAME_PROMOTION } from '@/modules/promotion/router';
import { useRfmPersonaList } from '@/modules/rfm/persona/model/list';
import { promotionService } from '@/services/promotion';
import { onMounted, reactive } from 'vue';
import { useRoute } from 'vue-router';

export function usePromotionItemDetail() {
    const route = useRoute();
    const router = useAppRouter();
    const crudAction = useCrudActions();

    const { personaMap, fetchPersonaAll } = useRfmPersonaList();

    const model = reactive({
        id: route.params.id,
        name: '',
        status: null,
        displayType: 0,
        fromTime: null,
        toTime: null,
        expectedPackage: 0,
        prototypeId: null,
        personas: [],
        canEnable: false,
        canDisable: false,
        canDelete: false
    });

    const fetch = crudAction.executeAction({
        request: () => promotionService.item.get(model.id),
        onSuccess: ({ data }) => {
            model.id = data.id;
            model.name = data.name;
            model.status = data.status;
            model.displayType = data.displayType;
            model.fromTime = new Date(data.fromTime);
            model.toTime = data?.toTime ? new Date(data.toTime) : null;
            model.expectedPackage = data.expectedPackage;
            model.prototypeId = data.usedPrototypeId;
            model.canEnable = data.canEnable;
            model.canDisable = data.canDisable;
            model.canDelete = data.canDelete;
            model.personas = data.personas.map((per: any) => ({
                ...per,
                rfmPersonaName: personaMap.value.get(per.rfmPersonaId)?.name
            }));
        },
        onError: () => router.push({ name: ROUTE_NAME_PROMOTION.ITEM.INDEX })
    });

    const actions = {
        remove: crudAction.confirmAndRemove({
            request: () => promotionService.item.remove(model.id),
            onSuccess: () => router.go(-1)
        }),
        disable: crudAction.confirmAndDisable({
            request: () => promotionService.item.disable(model.id),
            onSuccess: fetch
        }),
        enable: crudAction.confirmAndEnable({
            request: () => promotionService.item.enable(model.id),
            onSuccess: fetch
        })
    };

    onMounted(async () => {
        await fetchPersonaAll();
        await fetch();
    });

    return { model, actions };
}
